import { render, staticRenderFns } from "./Create2.vue?vue&type=template&id=f1bd38c6"
import script from "./Create2.vue?vue&type=script&lang=js"
export * from "./Create2.vue?vue&type=script&lang=js"
import style0 from "./Create2.vue?vue&type=style&index=0&id=f1bd38c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports